module.exports = __webpack_public_path__ + "img/ug341.d57cd086.png";